<template>
  <main>
    <v-toolbar class="cyan" app fixed dark>
      <v-toolbar-side-icon @click.stop="$root.$children[0]._data.drawer = !$root.$children[0]._data.drawer"></v-toolbar-side-icon>
      <v-toolbar-title v-if="currentDataset.meta.name">Bewertung: {{ currentDataset.meta.name }}</v-toolbar-title>
      <v-toolbar-title v-else>Bewertung</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>search</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>more_vert</v-icon>
      </v-btn>
    </v-toolbar>

    <v-content v-if="currentDataset.meta.name">
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12 sm4 lg3>
            <v-layout row>
              <v-flex xs12>
                <search-datasets :loading="loadingDatasetIndicator" :datasetsMeta="datasetsMeta.data"></search-datasets>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 sm8 lg9>
            <v-card>
              <v-tabs centered grow dark>
                <v-tabs-bar class="cyan">
                  <v-tabs-item :href="'#default-view'" ripple>Vereinfachte Ansicht</v-tabs-item>
                  <v-tabs-item :href="'#expert-view'" ripple>Expertenansicht</v-tabs-item>
                  <v-tabs-slider class="yellow"></v-tabs-slider>
                </v-tabs-bar>

                <v-card-text v-if="loadingDatasetIndicator" style="height: 490px">
                  <v-progress-circular indeterminate class="loading-dataset-indicator"></v-progress-circular>
                </v-card-text>

                <v-tabs-items v-show="!loadingDatasetIndicator">
                  <v-tabs-content :id="'default-view'">
                    <v-card-title primary-title>
                      <div>
                        <div class="headline">Bewertung</div>
                        <div class="body-2 grey--text">Füllen Sie die Felder aus, um eine Bewertung für den Datensatz vorzunehmen. Verwenden Sie die Expertenansicht, um mehrere Meta-Datensätze zu bearbeiten.</div>
                      </div>
                    </v-card-title>
                    <v-card-text>
                      <v-layout wrap>
                        <v-flex sm6 v-for="(items, itemName, index) in bewertungItems" :key="index">
                          <v-select
                            :items="items"
                            v-model="currentDataset.meta.bewertung[itemName]"
                            :label="itemName | uppercase"
                            item-value="'Noch offen'"
                          ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-tabs-content>
                  <v-tabs-content :id="'expert-view'">
                    <v-card-title primary-title>
                      <div>
                        <div class="headline">Bewertung</div>
                        <div class="body-2 grey--text">Füllen Sie die Felder aus, um eine Bewertung für den Datensatz vorzunehmen. Verwenden Sie die Expertenansicht, um mehrere Meta-Datensätze zu bearbeiten.</div>
                      </div>
                    </v-card-title>
                    <v-card-text>
                      <Spreadsheet :root="root" :data="datasetsMeta.data"></Spreadsheet>
                    </v-card-text>
                  </v-tabs-content>
                </v-tabs-items>
              </v-tabs>
              <v-card-actions>
                <v-btn flat color="primary">Änderungen speichern</v-btn>
                <v-btn flat>Abbrechen</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <v-content v-else>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <v-layout row>
              <v-flex xs12>
                <search-datasets :loading="loadingDatasetIndicator" :datasetsMeta="datasetsMeta.data" :show-hint="true"></search-datasets>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
          
  </main>
</template>

<script>
import Spreadsheet from 'vue-handsontable-official'
import SearchDatasets from '@/components/SearchDatasets'

export default {
  computed: {
    currentDataset () {
      return this.$store.getters.getCurrentDataset
    },
    datasetsMeta () {
      return this.$store.getters.getDatasetsMeta
    },
    loadingDatasetIndicator () {
      return this.$store.getters.getLoadingDatasetIndicator
    }
  },
  components: {
    Spreadsheet,
    SearchDatasets
  },
  data () {
    return {
      bewertungItems: {
        maschinenlesbarkeit: ['Nicht bekannt', 'Gar nicht bis gering', 'Überwiegend', 'Maschinenlesbar'],
        auffindbarkeit: ['Nicht bekannt', 'Keine Auszeichnung mit Metadaten', 'Nicht-standardisierte Auszeichnung mit Metadaten', 'Standardisierte Auszeichnung mit Metadaten'],
        nutzungsbedingungen: ['Nicht bekannt', 'Privatnutzung durch Dritte zugelassen', 'Nicht-kommerzielle Weiterverwendung', 'Kommerzielle Weiterverwendung'],
        nutzungskosten: ['Nicht bekannt', 'Nutzung nur gegen Geldleistung', 'Nicht-kommerz. Nutzung geldleistungsfrei', 'Kommerzielle Nutzung geldleistungsfrei'],
        verfuegbarkeit: ['Nicht bekannt', 'Undefiniert', 'Definiert, aber begrenzt', 'Definiert und unbegrenzt'],
        offeneStandards: ['Nicht bekannt', 'Proprietäre Formate', 'Standardisierte, aber nicht offene Formate', 'Standardisierte, offene Formate'],
        aktualisierungsrate: ['Nicht bekannt', 'Nein, keine Aktualisierungsrate', 'Ja, Aktualisierungsrate vorhanden'],
        oeffentlichesInteresse: ['Nicht bekannt', 'Geringes Interesse', 'Erhöhtes Interesse', 'Sehr hohes Interesse']
      },
      root: 'test-hot'
    }
  },
  methods: {},
  filters: {
    uppercase (string) {
      string = string.charAt(0).toUpperCase() + string.slice(1)
      string = string.replace(/ae/g, 'ä').replace(/Ae/g, 'Ä')
      string = string.replace(/ue/g, 'ü').replace(/Ue/g, 'Ü')
      string = string.replace(/oe/g, 'ö').replace(/Oe/g, 'Ö')
      string = string.replace(/([A-Z])/g, ' $1').trim()
      return string
    }
  }
}
</script>

<style>
#test-hot {
  height: 400px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/Bewertung.vue